'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.oembedToggle = twentyninetimes.oembedToggle || function () {

	function init() {
		var oembed_btns = document.querySelectorAll('.js-oembed-toggle');

		if ( oembed_btns && oembed_btns.length != 0 ) {
			var overlay = document.getElementById('js-oembed-overlay'),
				appendWrapper = overlay.querySelector('.oembed-overlay__inner');
				
			oembed_overlay_remove(overlay);

			oembed_btns.forEach(btn => {
				btn.addEventListener('click', function(e) {
					e.stopPropagation();

					var src 	= this.getAttribute('data-oembed-src'),
						new_src = src + '?&autoplay=1';

					if ( btn.classList.contains('js-oembed-autoplay-yes') ) {
						new_src += '&mute=1&background=1&rel=0';
					}

					if ( btn.classList.contains('js-oembed-inline') ) {
						var parent 	= this.parentNode;

						if ( !parent.classList.contains('has-media') ) {
							parent.classList.add('active');
							createIframe(new_src, parent, parent);
						}
					} else {
						if ( !overlay.classList.contains('has-media') ) {
							overlay.classList.add('active');
							overlay.classList.add('oembed-active');
							createIframe(new_src, overlay, appendWrapper);

							( document.documentElement )
								? document.documentElement.classList.add('no-scroll')
								: document.body.classList.add('no-scroll');

							bodyScrollLock.disableBodyScroll(overlay);
						}
					}
				});
			});
		}
	}

	function createIframe(src, elm, appendElm) {
		var	figure = document.createElement('figure'),
			  iframe = document.createElement('iframe');

		figure.setAttribute('class', 'oembed__inline-wrapper');
		iframe.setAttribute('src', src);
		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('allow', 'autoplay; fullscreen');
		iframe.setAttribute('allowfullscreen', '');

    figure.appendChild(iframe);
    appendElm.appendChild(figure);

    elm.classList.add('has-media');
	}

	function oembed_overlay_remove(overlay) {
		var overlay_inner = overlay.querySelector('.oembed-overlay__inner'),
			  overlay_close_btn = overlay.querySelector('.js-overlay-close');

		overlay_close_btn.addEventListener('click', function(e) {
			e.stopPropagation();

			if ( overlay.classList.contains('active') ) {

				overlay.classList.remove('active');
				overlay.classList.add('remove-media');

				( document.documentElement )
					? document.documentElement.classList.remove('no-scroll')
					: document.body.classList.remove('no-scroll');

				bodyScrollLock.enableBodyScroll(overlay);

				setTimeout(function() {
					overlay_inner.innerHTML = '';
				}, 600);

				setTimeout(function() {
					overlay.classList.remove('has-media', 'remove-media', 'oembed-active');
				}, 1200);
			}
		});
	}

	return {
		init : init
	};

}();